var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 84,
    viewBox: "0 0 86 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V84H85.1728V0H0ZM43.679 6.58847C48.3512 6.58845 52.9776 7.50868 57.2941 9.29664C61.6107 11.0846 65.5328 13.7053 68.8365 17.009C72.1403 20.3127 74.7609 24.2348 76.5489 28.5514C78.3368 32.8679 79.2571 37.4944 79.257 42.1665C79.257 51.6024 75.5085 60.6517 68.8364 67.3238C62.1642 73.9959 53.1148 77.7442 43.679 77.7442C34.2432 77.7441 25.1939 73.9958 18.5218 67.3237C11.8497 60.6516 8.10137 51.6023 8.10131 42.1665C8.10126 32.7307 11.8496 23.6813 18.5217 17.0091C25.1938 10.337 34.2431 6.58853 43.679 6.58847Z",
    fill: "url(#paint0_radial_3543_43724)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_0_3543_43724_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 0,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3945 26.7922C31.1201 21.9612 34.9728 22.8407 37.8565 24.2338L64.7194 40.2237C66.7249 41.9177 67.4803 43.6599 64.293 45.5536L37.4301 61.3303C33.5941 63.3008 31.2524 61.8169 30.3945 58.9851V26.7922Z",
    fill: "#11B0FF",
    fillOpacity: 0.779874
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5816 76.5714C62.5726 76.5714 77.9679 61.1761 77.9679 42.1851C77.9679 23.1941 62.5726 7.79883 43.5816 7.79883C24.5906 7.79883 9.19531 23.1941 9.19531 42.1851C9.19531 61.1761 24.5906 76.5714 43.5816 76.5714Z",
    stroke: "#11B0FF",
    strokeOpacity: 0.396078,
    strokeWidth: 2.51282
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3543_43724_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3945 26.7922C31.1201 21.9612 34.9728 22.8407 37.8565 24.2338L64.7194 40.2237C66.7249 41.9177 67.4803 43.6599 64.293 45.5536L37.4301 61.3303C33.5941 63.3008 31.2524 61.8169 30.3945 58.9851V26.7922Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3543_43724",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5016 42.5695) rotate(-89.5241) scale(43.4089 42.3657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B0FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.206c749c89ee1ee357641e7eb87a899b.svg";
export { ForwardRef as ReactComponent };